import { render, staticRenderFns } from "./ab-action-btn.vue?vue&type=template&id=6aec8e36"
import script from "./ab-action-btn.vue?vue&type=script&lang=js"
export * from "./ab-action-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports